/** @file tileTabLabel: the top-bar label of a Tile tab, `<drawable> <angle>°`. */
import type { Puppet } from '@zilo/pose3d-format/types/puppet';
import type { TileRef } from '../../state/editorTypes';
import { tileAzimuth } from './tileAzimuth';

/** `head 45°` (one decimal at most); `head #2` when the angle is unknown (no document yet, or a stale tab). */
export function tileTabLabel(puppet: Puppet | null, ref: TileRef): string {
  const deg = puppet === null ? null : tileAzimuth(puppet, ref);
  return deg === null ? `${ref.drawable} #${String(ref.tile)}` : `${ref.drawable} ${String(Math.round(deg * 10) / 10)}°`;
}
